module.exports = __webpack_public_path__ + "img/Antargaz_120X35.91ed3f5c.png";